
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("babkf", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $9K4OG = parcelRequire("9K4OG");


var $42omo = parcelRequire("42omo");


var $fFa3V = parcelRequire("fFa3V");


var $cKx73 = parcelRequire("cKx73");


var $d925B = parcelRequire("d925B");


var $kSoKM = parcelRequire("kSoKM");

var $bWRlG = parcelRequire("bWRlG");


var $aFUXX = parcelRequire("aFUXX");


var $6R5uz = parcelRequire("6R5uz");


var $3gadb = parcelRequire("3gadb");


var $g9Jfe = parcelRequire("g9Jfe");


var $1oCLl = parcelRequire("1oCLl");


var $fjRlK = parcelRequire("fjRlK");


var $aXWIB = parcelRequire("aXWIB");


var $59U23 = parcelRequire("59U23");


var $9KIOh = parcelRequire("9KIOh");

function $fa3a871ee2099f32$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $fa3a871ee2099f32$var$titleStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    outline: 'none',
    border: 'none',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    fontSize: `${0.875}rem`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/design-system/use-tokens-typography -- Ignored via go/DSP-18766
    lineHeight: (0, $aFUXX.akEditorLineHeight),
    fontWeight: "var(--ds-font-weight-regular, 400)",
    display: 'flex',
    flex: 1,
    margin: 0,
    padding: `0 0 0 ${"var(--ds-space-050, 4px)"}`,
    textAlign: 'left'
});
const $fa3a871ee2099f32$var$titleStylesDense = {
    name: "13vs5qp",
    styles: "font-size:var(--ak-renderer-base-font-size)"
};
const $fa3a871ee2099f32$var$containerStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    borderWidth: "var(--ds-border-width, 1px)",
    borderStyle: 'solid',
    borderColor: 'transparent',
    borderRadius: "var(--ds-radius-small, 4px)",
    minHeight: '25px',
    background: "var(--ds-background-neutral-subtle, #00000000)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    transition: `background 0.3s ${(0, $aFUXX.akEditorSwoopCubicBezier)}, border-color 0.3s ${(0, $aFUXX.akEditorSwoopCubicBezier)}`,
    padding: "var(--ds-space-0, 0px)",
    paddingBottom: "var(--ds-space-0, 0px)",
    marginTop: "var(--ds-space-050, 4px)",
    marginBottom: 0,
    marginLeft: 0,
    marginRight: 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    'td > :not(style):first-child, td > style:first-child + *': {
        marginTop: 0
    }
});
const $fa3a871ee2099f32$var$containerStylesExpanded = {
    name: "mpp6x6",
    styles: "background:var(--ds-surface, #FFFFFF);padding-bottom:var(--ds-space-100, 8px);border-color:var(--ds-border, #0B120E24)"
};
const $fa3a871ee2099f32$var$containerStylesFocused = {
    name: "pkf2kr",
    styles: "border-color:var(--ds-border-focused, #4688EC)"
};
const $fa3a871ee2099f32$var$containerStylesDataNodeTypeExpand = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    marginLeft: `-${(0, $aFUXX.akLayoutGutterOffset)}px`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    marginRight: `-${(0, $aFUXX.akLayoutGutterOffset)}px`
});
const $fa3a871ee2099f32$var$titleContainerStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    display: 'flex',
    alignItems: 'flex-start',
    background: 'none',
    border: 'none',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    fontSize: `${0.875}rem`,
    width: '100%',
    color: "var(--ds-text-subtle, #505258)",
    overflow: 'hidden',
    cursor: 'pointer',
    padding: "var(--ds-space-100, 8px)",
    '&:focus': {
        outline: 0
    }
});
const $fa3a871ee2099f32$var$titleContainerStylesExpanded = {
    name: "dkidh7",
    styles: "padding-bottom:var(--ds-space-0, 0px)"
}; // Base styles for the content container. visibility:hidden hides collapsed content.
// When browser find is enabled, the useEffect clears visibility:hidden after setting
// hidden="until-found" on the DOM element, which applies content-visibility:hidden natively —
// this hides the content while allowing browser Ctrl+F to index the text.
// The visibility:hidden in CSS serves as an SSR fallback (useEffect doesn't run server-side).
const $fa3a871ee2099f32$var$contentContainerStyles = {
    name: "br2f98",
    styles: "padding-top:var(--ds-space-0, 0px);margin-left:var(--ds-space-050, 4px);padding-right:var(--ds-space-200, 16px);padding-left:var(--ds-space-400, 32px);visibility:hidden;@supports not (display: flow-root){width:100%;box-sizing:border-box;}"
}; // display:flow-root is applied only when browser find is NOT enabled.
// It must NOT be set when browser find is enabled — it overrides the
// content-visibility:hidden applied by hidden="until-found" and makes content visible.
const $fa3a871ee2099f32$var$contentContainerStylesFlowRoot = {
    name: "12r8j1i",
    styles: "display:flow-root"
};
const $fa3a871ee2099f32$var$contentContainerStylesExpanded = {
    name: "xhzdsf",
    styles: "padding-top:var(--ds-space-100, 8px);visibility:visible"
};
const $fa3a871ee2099f32$var$contentContainerStylesNotExpanded = {
    name: "1njmbsg",
    styles: ".expand-content-wrapper, .nestedExpand-content-wrapper{width:100%;display:block;height:0;overflow:hidden;clip:rect(1px, 1px, 1px, 1px);user-select:none;}"
}; // When browser find is enabled and expand is collapsed, we rely on the
// hidden="until-found" attribute on the outer container to hide content.
// We remove height:0/overflow:hidden/clip from the inner wrapper so the
// browser can actually search through the content.
const $fa3a871ee2099f32$var$contentContainerStylesNotExpandedBrowserFind = {
    name: "1q6kyzt",
    styles: ".expand-content-wrapper, .nestedExpand-content-wrapper{width:100%;display:block;user-select:none;}"
};
const $fa3a871ee2099f32$var$clearNextSiblingMarginTopStyle = {
    name: "1f3w791",
    styles: "& + *{margin-top:0 !important;}"
}; // Lazy-loaded children component
const $fa3a871ee2099f32$var$LazyChildren = /*#__PURE__*/ (0, $42omo.lazy)(()=>{
    return Promise.resolve({
        default: ({ children: children })=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
        }
    });
});
const $fa3a871ee2099f32$var$Container = (props)=>{
    return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: [
            $fa3a871ee2099f32$var$containerStyles,
            props['data-node-type'] === 'expand' && $fa3a871ee2099f32$var$containerStylesDataNodeTypeExpand,
            props.expanded && $fa3a871ee2099f32$var$containerStylesExpanded,
            props.focused && $fa3a871ee2099f32$var$containerStylesFocused
        ],
        "data-testid": props['data-testid'],
        "data-node-type": props['data-node-type'],
        "data-title": props['data-title'],
        "data-expanded": props['data-expanded'],
        "data-local-id": props['data-local-id']
    }, props.children);
};
const $fa3a871ee2099f32$var$TitleContainer = (props)=>{
    const { expanded: expanded } = props;
    return /*#__PURE__*/ (0, $9K4OG.jsx)("button", {
        type: "button",
        css: [
            $fa3a871ee2099f32$var$titleContainerStyles,
            expanded && $fa3a871ee2099f32$var$titleContainerStylesExpanded
        ],
        onClick: props.onClick,
        onFocus: props.onFocus,
        onBlur: props.onBlur,
        "aria-labelledby": props['aria-labelledby'],
        "aria-expanded": props['aria-expanded'],
        contentEditable: props.contentEditable
    }, props.children);
};
$fa3a871ee2099f32$var$TitleContainer.displayName = 'TitleContainerButton';
const $fa3a871ee2099f32$var$ContentContainer = (props)=>{
    return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        ref: props.contentRef,
        css: [
            $fa3a871ee2099f32$var$contentContainerStyles,
            !props.enableBrowserFind && $fa3a871ee2099f32$var$contentContainerStylesFlowRoot,
            props.expanded && $fa3a871ee2099f32$var$contentContainerStylesExpanded,
            !props.expanded && (props.enableBrowserFind ? $fa3a871ee2099f32$var$contentContainerStylesNotExpandedBrowserFind : $fa3a871ee2099f32$var$contentContainerStylesNotExpanded)
        ]
    }, props.children);
};
function $fa3a871ee2099f32$var$fireExpandToggleAnalytics(nodeType, expanded, fireAnalyticsEvent) {
    if (!fireAnalyticsEvent) return;
    fireAnalyticsEvent({
        action: (0, $d925B.ACTION).TOGGLE_EXPAND,
        actionSubject: nodeType === 'expand' ? (0, $d925B.ACTION_SUBJECT).EXPAND : (0, $d925B.ACTION_SUBJECT).NESTED_EXPAND,
        attributes: {
            platform: (0, $59U23.PLATFORM).WEB,
            mode: (0, $59U23.MODE).RENDERER,
            expanded: !expanded
        },
        eventType: (0, $d925B.EVENT_TYPE).TRACK
    });
}
function $fa3a871ee2099f32$var$Expand({ title: title, children: children, nodeType: nodeType, intl: intl, fireAnalyticsEvent: fireAnalyticsEvent, localId: localId, nestedHeaderIds: nestedHeaderIds, rendererContentMode: rendererContentMode, loadBodyContent: loadBodyContent, searchText: searchText }) {
    const [expanded, setExpanded] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState(false);
    const [focused, setFocused] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState(false);
    const [hasLoadedChildren, setHasLoadedChildren] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState(false);
    const isMobile = false;
    const label = intl.formatMessage(expanded ? (0, $kSoKM.messages).collapseNode : (0, $kSoKM.messages).expandNode);
    const { current: id } = (0, $42omo.useRef)((0, (/*@__PURE__*/$parcel$interopDefault($fjRlK)))('expand-title-'));
    const contentContainerRef = (0, $42omo.useRef)(null);
    const contentWrapperRef = (0, $42omo.useRef)(null);
    const handleFocus = (0, $42omo.useCallback)(()=>setFocused(true), []);
    const handleBlur = (0, $42omo.useCallback)(()=>setFocused(false), []);
    const expandForBrowserFind = (0, $42omo.useCallback)(()=>{
        setHasLoadedChildren(true);
        setExpanded(true);
    }, []);
    const shouldRenderLazyChildren = hasLoadedChildren || loadBodyContent; // Only render the lightweight text placeholder when lazy load is ON and
    // children haven't been loaded yet. When lazy load is OFF, children are
    // always in the DOM — hidden="until-found" on the wrapper already makes
    // them searchable by browser find, so no placeholder is needed.
    const shouldRenderBrowserFindText = !shouldRenderLazyChildren && searchText && (0, $g9Jfe.fg)('hot-121622_lazy_load_expand_content') && (0, $1oCLl.expValEquals)('platform_editor_close_expand_find', 'isEnabled', true); // Feature-detect hidden="until-found" support via the beforematch event.
    // Chrome 102+ and Firefox 130+ support it; Safari does not yet.
    // In unsupported browsers, setting hidden="until-found" is treated as boolean hidden
    // (display:none), which would break the expand entirely.
    // Initialised as false and set in useEffect to avoid SSR/client hydration mismatch —
    // useMemo would return true on the client's first render in supported browsers,
    // differing from the server snapshot which always produces false.
    const [supportsHiddenUntilFound, setSupportsHiddenUntilFound] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState(false);
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(()=>{
        const doc = (0, $cKx73.getDocument)();
        setSupportsHiddenUntilFound(doc?.body ? 'onbeforematch' in doc.body : false);
    }, []); // React 18 treats `hidden` as a boolean attribute and strips the "until-found" value,
    // rendering it as just `hidden` (which applies display:none and blocks find-in-page).
    // We bypass React by setting the attribute directly on the DOM element around the text.
    //
    // We also remove the CSS visibility:hidden (SSR fallback) once hidden="until-found" is set,
    // because visibility:hidden blocks browser find. On expanded, we restore visibility to visible.
    //
    // Only applied when the browser supports hidden="until-found" (detected via onbeforematch).
    // In unsupported browsers (Safari), we skip this entirely and fall back to the normal
    // CSS hiding (visibility:hidden + height:0), which doesn't support find-in-page but
    // still works correctly for expand/collapse.
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(()=>{
        const contentContainer = contentContainerRef.current;
        const contentWrapper = contentWrapperRef.current;
        if (!contentWrapper) return;
        if (supportsHiddenUntilFound && (0, $1oCLl.expValEquals)('platform_editor_close_expand_find', 'isEnabled', true) && !expanded) {
            contentWrapper.setAttribute('hidden', 'until-found'); // Override the CSS visibility:hidden from contentContainerStyles — hidden="until-found"
            // now handles hiding via content-visibility:hidden, which allows browser find to index
            // the content. We use 'visible' (not '') because '' only clears the inline style but
            // the Emotion CSS class rule still applies visibility:hidden, blocking find-in-page.
            contentContainer?.style.setProperty('visibility', 'visible');
            contentWrapper.style.visibility = 'visible';
        } else {
            contentWrapper.removeAttribute('hidden');
            contentContainer?.style.removeProperty('visibility');
            contentWrapper.style.visibility = '';
        }
    }, [
        expanded,
        supportsHiddenUntilFound
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(()=>{
        if (!(0, $1oCLl.expValEquals)('platform_editor_close_expand_find', 'isEnabled', true) || expanded) return;
        const contentWrapper = contentWrapperRef.current;
        const unbindWrapperBeforeMatch = contentWrapper && supportsHiddenUntilFound ? (0, $fFa3V.bind)(contentWrapper, {
            type: 'beforematch',
            listener: expandForBrowserFind
        }) : undefined;
        return ()=>{
            unbindWrapperBeforeMatch?.();
        };
    }, [
        expandForBrowserFind,
        expanded,
        supportsHiddenUntilFound
    ]);
    let expandContent = children;
    if (shouldRenderBrowserFindText) // Browser find path: keep a lightweight text mirror in the closed expand
    // so Ctrl+F can index it without mounting the rich children tree.
    expandContent = /*#__PURE__*/ (0, $9K4OG.jsx)("span", null, searchText);
    else if (!shouldRenderLazyChildren && (0, $g9Jfe.fg)('hot-121622_lazy_load_expand_content')) expandContent = null;
    else if ((0, $g9Jfe.fg)('hot-121622_lazy_load_expand_content')) expandContent = /*#__PURE__*/ (0, $9K4OG.jsx)((0, $42omo.Suspense), {
        fallback: /*#__PURE__*/ (0, $9K4OG.jsx)("div", null, intl.formatMessage((0, $kSoKM.messages).loading))
    }, /*#__PURE__*/ (0, $9K4OG.jsx)($fa3a871ee2099f32$var$LazyChildren, null, children));
    return /*#__PURE__*/ (0, $9K4OG.jsx)($fa3a871ee2099f32$var$Container, {
        "data-testid": `expand-container-${nodeType}-${id}`,
        "data-node-type": nodeType,
        "data-title": title,
        "data-expanded": expanded,
        "data-local-id": localId,
        expanded: expanded,
        focused: focused
    }, nestedHeaderIds && nestedHeaderIds.length > 0 ? /*#__PURE__*/ (0, $9K4OG.jsx)((0, $9KIOh.ActiveHeaderIdConsumer), {
        nestedHeaderIds: nestedHeaderIds,
        onNestedHeaderIdMatch: ()=>{
            if (!hasLoadedChildren) setHasLoadedChildren(true);
            setExpanded(true);
        }
    }) : null, /*#__PURE__*/ (0, $9K4OG.jsx)($fa3a871ee2099f32$var$TitleContainer // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
    , {
        onClick: (e)=>{
            e.preventDefault();
            e.stopPropagation();
            $fa3a871ee2099f32$var$fireExpandToggleAnalytics(nodeType, expanded, fireAnalyticsEvent); // Mark children as loaded when expanding for the first time
            if (!expanded && !hasLoadedChildren) setHasLoadedChildren(true);
            setExpanded(!expanded);
            e.persist(); // @ts-ignore detail doesn't exist on type
            e.detail ? handleBlur() : handleFocus();
        },
        onFocus: handleFocus,
        onBlur: handleBlur,
        "aria-labelledby": id,
        "aria-expanded": expanded,
        contentEditable: false,
        expanded: expanded
    }, isMobile ? /*#__PURE__*/ (0, $9K4OG.jsx)((0, $kSoKM.ExpandIconWrapper), {
        expanded: expanded
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6R5uz))), {
        label: label,
        spacing: "spacious",
        size: "small"
    })) : /*#__PURE__*/ (0, $9K4OG.jsx)((0, $3gadb.default), {
        content: label,
        position: "top",
        tag: (0, $kSoKM.ExpandLayoutWrapperWithRef),
        testId: 'tooltip'
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $kSoKM.ExpandIconWrapper), {
        expanded: expanded
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6R5uz))), {
        label: label,
        spacing: "spacious",
        size: "small"
    }))), /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
        css: [
            $fa3a871ee2099f32$var$titleStyles,
            rendererContentMode === 'compact' && $fa3a871ee2099f32$var$titleStylesDense
        ],
        id: id
    }, title || intl.formatMessage((0, $kSoKM.messages).expandDefaultTitle))), /*#__PURE__*/ (0, $9K4OG.jsx)($fa3a871ee2099f32$var$ContentContainer, {
        expanded: expanded,
        enableBrowserFind: supportsHiddenUntilFound && (0, $1oCLl.expValEquals)('platform_editor_close_expand_find', 'isEnabled', true),
        contentRef: contentContainerRef
    }, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        className: `${nodeType}-content-wrapper`,
        ref: contentWrapperRef
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $bWRlG.WidthProvider), null, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: $fa3a871ee2099f32$var$clearNextSiblingMarginTopStyle
    }), expandContent))));
}
// eslint-disable-next-line @typescript-eslint/ban-types
const $fa3a871ee2099f32$var$_default_1 = (0, $aXWIB.injectIntl)($fa3a871ee2099f32$var$Expand);
var $fa3a871ee2099f32$export$2e2bcd8739ae039 = $fa3a871ee2099f32$var$_default_1;
module.exports["default"] = $fa3a871ee2099f32$export$2e2bcd8739ae039;

});

parcelRegister("kSoKM", function(module, exports) {
/* eslint-disable @atlaskit/ui-styling-standard/use-compiled -- Pre-existing lint debt surfaced by this mechanical type-import-only PR. */ /**
* @jsxRuntime classic
* @jsx jsx
*/ 
var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $aXWIB = parcelRequire("aXWIB");


var $aFUXX = parcelRequire("aFUXX");

function $095aa81eb4c35edf$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $095aa81eb4c35edf$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    loading: {
        id: "fabric.editor.expand.loading",
        defaultMessage: "Loading..."
    },
    collapseNode: {
        id: "fabric.editor.collapseNode",
        defaultMessage: "Collapse content"
    },
    expandDefaultTitle: {
        id: "fabric.editor.expandDefaultTitle",
        defaultMessage: "Click here to expand..."
    },
    expandNode: {
        id: "fabric.editor.expandNode",
        defaultMessage: "Expand content"
    },
    expandPlaceholderText: {
        id: "fabric.editor.expandPlaceholder",
        defaultMessage: "Give this expand a title..."
    },
    expandArialabel: {
        id: "fabric.editor.expandAriaLabel",
        defaultMessage: "Give this expand a title"
    },
    expandBodyAriaLabel: {
        id: "fabric.editor.expandBodyAriaLabel",
        defaultMessage: "Expand body content"
    }
});
const $095aa81eb4c35edf$export$4eeef63d68e77552 = ({ children: children, expanded: expanded })=>{
    return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: ()=>expanded ? [
                $095aa81eb4c35edf$var$expandIconWrapperStyle(),
                $095aa81eb4c35edf$var$expandIconWrapperExpandedStyle
            ] : $095aa81eb4c35edf$var$expandIconWrapperStyle()
    }, children);
};
const $095aa81eb4c35edf$var$expandIconWrapperStyle = ()=>/*#__PURE__*/ (0, $9K4OG.css)({
        cursor: 'pointer',
        display: 'flex',
        color: "var(--ds-icon, #292A2E)",
        borderRadius: "var(--ds-radius-small, 4px)",
        width: '24px',
        height: '24px',
        '&:hover': {
            background: "var(--ds-background-neutral-subtle-hovered, #0515240F)"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        svg: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            transition: `transform 0.2s ${(0, $aFUXX.akEditorSwoopCubicBezier)}`
        }
    });
const $095aa81eb4c35edf$var$expandIconWrapperExpandedStyle = {
    name: "1uoxr6z",
    styles: "svg{transform:rotate(90deg);}"
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/volt-strict-mode/no-multiple-exports -- Ignored via go/DSP-18766
const $095aa81eb4c35edf$export$a7ed6bf20867161a = {
    name: "ljflj6",
    styles: "width:var(--ds-space-300, 24px);height:var(--ds-space-300, 24px)"
}; // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
const $095aa81eb4c35edf$export$c67faf67c1185cba = /*#__PURE__*/ (0, $42omo.forwardRef)(({ children: children, ...otherProps }, ref)=>{
    return /*#__PURE__*/ (0, $9K4OG.jsx)("div" // Ignored via go/ees005
    , {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        css: $095aa81eb4c35edf$export$a7ed6bf20867161a,
        ref: ref,
        ...otherProps
    }, children);
});
module.exports["messages"] = $095aa81eb4c35edf$export$defe85febe8b728c;
module.exports["ExpandIconWrapper"] = $095aa81eb4c35edf$export$4eeef63d68e77552;
module.exports["expandLayoutWrapperStyle"] = $095aa81eb4c35edf$export$a7ed6bf20867161a;
module.exports["ExpandLayoutWrapperWithRef"] = $095aa81eb4c35edf$export$c67faf67c1185cba;

});


//# sourceMappingURL=Expand.5c3ad6df.js.map
